var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiceRed6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-678 -265) translate(48 265) translate(630)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#FF4664",
    fillOpacity: 0.3,
    rx: 28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 57,
    fill: "#FF4664",
    stroke: "#FF7C91"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 79.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 60.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 60.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 79.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 40.5,
    r: 8.5,
    fill: "#FFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceRed6);
export default __webpack_public_path__ + "static/media/dice-red-6.3ee98ff0915e6c2e2fc9a18ae0370889.svg";
export { ForwardRef as ReactComponent };